export default __webpack_public_path__ + "dist/media/Templates-2.3f87f0c7.svg";